module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginpage"
  }, [_c('div', {
    staticClass: "login-box",
    class: {
      changewidth: _vm.isActive
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/login/logopaybay.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "login-title",
    staticStyle: {
      "font-size": "32px"
    }
  }, [_vm._v("数字标牌")]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loginload),
      expression: "loginload"
    }],
    ref: "loginForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "element-loading-text": "正在登陆，请稍后。。。"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e8abe83!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wcLogin.vue
// module id = 1054
// module chunks = 2